// Brand assets supplied directly by the user (logo, audio, real photos).
export const BRAND = {
  logo: "https://customer-assets.emergentagent.com/job_place-stories-70/artifacts/frktemmk_talking%20trails%20-%20logo.png",
  appMockup: "https://customer-assets.emergentagent.com/job_place-stories-70/artifacts/lt0ighya_talking%20trails%20app.png",
  signageHero: "https://customer-assets.emergentagent.com/job_place-stories-70/artifacts/3o16betz_Talking%20trails%20interpretive%20signage.png",
  studioStoryteller: "https://customer-assets.emergentagent.com/job_place-stories-70/artifacts/p4h452sf_willie%20brim%20studio%20-%20talking%20trails.jpg",
  nyinkkaCentre: "https://customer-assets.emergentagent.com/job_place-stories-70/artifacts/k0qrc9et_Screenshot%202026-06-14%20at%2012.05.11%E2%80%AFpm.png",
  homeHero: "https://customer-assets.emergentagent.com/job_place-stories-70/artifacts/wm5umam7_talking%20trails%20hero%20image%20-%20homepage.jpg",
  familyOnTrail: "https://customer-assets.emergentagent.com/job_place-stories-70/artifacts/c84jh52h_talking%20trails%20-%20family.jpg",
  elderStoryteller: "https://customer-assets.emergentagent.com/job_place-stories-70/artifacts/38maza0i_Clohesy-River-Fig-Tree-Willie-Brim-85967.jpg",
  openingAudio: "https://customer-assets.emergentagent.com/job_place-stories-70/artifacts/5a0xkcrn_Tallking%20Trails%20-%20Talking%20Trails%20Opening.mp3",
};

// Curated image assets — sourced via Unsplash for environmental imagery.
export const IMAGES = {
  heroRainforest:
    "https://images.unsplash.com/photo-1592288801240-7b18bb06e94f?auto=format&fit=crop&w=2200&q=80",
  kurandaTrail:
    "https://images.unsplash.com/photo-1775799299840-794e5d4cfea7?auto=format&fit=crop&w=1800&q=80",
  byronBay:
    "https://images.unsplash.com/photo-1730003326703-28bc213725df?auto=format&fit=crop&w=1800&q=80",
  heritageBuilding:
    "https://images.unsplash.com/photo-1470294402047-fc1b5f39bd99?auto=format&fit=crop&w=1800&q=80",
  outback:
    "https://images.unsplash.com/photo-1581716664010-2ba06ce8f51a?auto=format&fit=crop&w=1800&q=80",
  redCentre:
    "https://images.unsplash.com/photo-1529108190281-9a4f620bc2d8?auto=format&fit=crop&w=1800&q=80",
  desertRock:
    "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?auto=format&fit=crop&w=1800&q=80",
  desertSculpture:
    "https://images.unsplash.com/photo-1518495973542-4542c06a5843?auto=format&fit=crop&w=1800&q=80",
  rainforestPath:
    "https://images.unsplash.com/photo-1448375240586-882707db888b?auto=format&fit=crop&w=1800&q=80",
  coastalPath:
    "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1800&q=80",
  river:
    "https://images.unsplash.com/photo-1501785888041-af3ef285b470?auto=format&fit=crop&w=1800&q=80",
  signage:
    "https://images.unsplash.com/photo-1542359649-31e03cd4d909?auto=format&fit=crop&w=1800&q=80",
  storyteller:
    "https://images.unsplash.com/photo-1517486808906-6ca8b3f04846?auto=format&fit=crop&w=1800&q=80",
  walking:
    "https://images.unsplash.com/photo-1551632811-561732d1e306?auto=format&fit=crop&w=1800&q=80",
  lighthouse:
    "https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=1800&q=80",
  mossPath:
    "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?auto=format&fit=crop&w=1800&q=80",
  hinterland:
    "https://images.unsplash.com/photo-1502082553048-f009c37129b9?auto=format&fit=crop&w=1800&q=80",
};

export const TRAILS = {
  kuranda: {
    slug: "kuranda",
    name: "Kuranda Talking Trails",
    shortName: "Kuranda",
    badge: "https://customer-assets.emergentagent.com/job_place-stories-70/artifacts/z9r5me5q_kuranda-talking-trails%20logo.png",
    region: "Far North Queensland",
    distance: "3.2 km loop",
    duration: "75 min",
    stops: "40+",
    hero: IMAGES.kurandaTrail,
    secondary: IMAGES.rainforestPath,
    tertiary: IMAGES.river,
    gallery: [
      "https://customer-assets.emergentagent.com/job_place-stories-70/artifacts/coww2cws_1423746_barron-river-in-queensland-australia%202.jpg",
      "https://customer-assets.emergentagent.com/job_place-stories-70/artifacts/xrynendd_DSCN2426.JPG",
      "https://customer-assets.emergentagent.com/job_place-stories-70/artifacts/q2pgj20z_5871766_rain-forest-on-the-road-to-kuranda.jpg",
    ],
    intro:
      "Explore the rainforest village through stories of culture, rail, river, landscape, community and local history. Local voices guide you between the Barron River, the railway station and the heart of Kuranda Village across more than forty listening stops.",
    themes: ["Rainforest", "Barron River", "Railway heritage", "Djabugay Country", "Village life"],
    stopList: [
      { n: 1, title: "Welcome to Kuranda", subtitle: "Stepping into rainforest Country", coords: [12, 18], duration: "4:12" },
      { n: 2, title: "Kuranda Railway Station", subtitle: "Iron through the rainforest", coords: [28, 32], duration: "5:48" },
      { n: 3, title: "Rainforest Canopy Walk", subtitle: "A vertical world", coords: [38, 48], duration: "3:55" },
      { n: 4, title: "Riverside Markets", subtitle: "Hands that make a village", coords: [60, 60], duration: "4:33" },
      { n: 5, title: "Honey House Heritage", subtitle: "A century of beekeepers", coords: [70, 50], duration: "3:18" },
      { n: 6, title: "Coondoo Street", subtitle: "Wandering and listening", coords: [78, 66], duration: "5:02" },
      { n: 7, title: "Jumrum Creek", subtitle: "Closing with water", coords: [85, 78], duration: "4:46" },
    ],
  },
  "byron-bay": {
    slug: "byron-bay",
    name: "Byron Bay Talking Trails",
    shortName: "Byron Bay",
    badge: "https://customer-assets.emergentagent.com/job_place-stories-70/artifacts/e7hx1f13_bbwt.png",
    region: "Northern Rivers, NSW",
    distance: "4.1 km point-to-point",
    duration: "90 min",
    stops: 28,
    hero: IMAGES.byronBay,
    secondary: IMAGES.coastalPath,
    tertiary: IMAGES.lighthouse,
    gallery: [
      IMAGES.byronBay,
      "https://customer-assets.emergentagent.com/job_place-stories-70/artifacts/0e5xxmhm_devices.jpg",
      IMAGES.coastalPath,
    ],
    intro:
      "Byron Bay comes to life as you walk from the headland to the hinterland with Byron Bay Talking Trails.",
    themes: ["Cape Byron", "Arakwal Country", "Surf culture", "Music & creativity", "Coastal ecology"],
    sampleAudio: "https://customer-assets.emergentagent.com/job_place-stories-70/artifacts/qyhb6ie1_Tour%20Sampler.mp3",
    stopList: [
      { n: 1, title: "The Shipwreck", subtitle: "What the sea remembers", coords: [18, 22], duration: "5:08" },
      { n: 2, title: "Wategos Beach", subtitle: "Naming the bay", coords: [26, 34], duration: "4:22" },
      { n: 3, title: "The Pass", subtitle: "Surf, swell and Country", coords: [34, 46], duration: "6:11" },
      { n: 4, title: "Clarkes Beach", subtitle: "Wind, sand, listening", coords: [44, 54], duration: "3:48" },
      { n: 5, title: "Main Beach", subtitle: "Town meets ocean", coords: [54, 62], duration: "4:39" },
      { n: 6, title: "Jonson Street", subtitle: "Music and main street", coords: [62, 70], duration: "5:25" },
      { n: 7, title: "Railway Park", subtitle: "Voices of community", coords: [72, 60], duration: "4:14" },
      { n: 8, title: "Belongil Creek", subtitle: "Estuary ecology", coords: [80, 50], duration: "5:46" },
      { n: 9, title: "Hinterland Lookout", subtitle: "Looking back over Country", coords: [88, 36], duration: "6:32" },
    ],
  },
  "nyinkka-nyunyu": {
    slug: "nyinkka-nyunyu",
    name: "Nyinkka Nyunyu Art & Culture Centre",
    shortName: "Nyinkka Nyunyu",
    region: "Tennant Creek, NT · Warumungu Country",
    distance: "1.4 km on-site walk",
    duration: "60 min",
    stops: 12,
    hero: BRAND.nyinkkaCentre,
    secondary: IMAGES.desertRock,
    tertiary: IMAGES.redCentre,
    gallery: [
      "https://customer-assets.emergentagent.com/job_place-stories-70/artifacts/k0qrc9et_Screenshot%202026-06-14%20at%2012.05.11%E2%80%AFpm.png",
      "https://customer-assets.emergentagent.com/job_place-stories-70/artifacts/gwdeq0jp_tennant_creek_pebbles_rights.jpg",
      "https://customer-assets.emergentagent.com/job_place-stories-70/artifacts/3yfzloi5_slide-02-1920x1000.jpg",
    ],
    sampleAudio: "https://customer-assets.emergentagent.com/job_place-stories-70/artifacts/gzteplto_Nyinkka%20Trail.MP3",
    intro:
      "Step onto Warumungu Country at Nyinkka Nyunyu — the Art & Culture Centre in Tennant Creek. Twelve listening stops weave together Songlines, sacred sites, bush tucker, art, sculpture and the living history of the Warumungu people.",
    themes: ["Warumungu Country", "Songlines", "Nyinkka site", "Bush tucker", "Art & sculpture", "Community history"],
    stopList: [
      { n: 1, title: "Welcome to Country", subtitle: "Standing on Warumungu land", coords: [10, 16], duration: "4:48" },
      { n: 2, title: "The Nyinkka", subtitle: "The spiny-tailed goanna ancestor", coords: [20, 26], duration: "5:32" },
      { n: 3, title: "Sacred Site", subtitle: "Why this place matters", coords: [28, 38], duration: "6:14" },
      { n: 4, title: "Songlines of the Desert", subtitle: "Tracks across Country", coords: [38, 28], duration: "5:46" },
      { n: 5, title: "Outdoor Sculpture Garden", subtitle: "Art made on Country", coords: [46, 44], duration: "4:22" },
      { n: 6, title: "Bush Tucker Walk", subtitle: "Food from the land", coords: [54, 58], duration: "5:08" },
      { n: 7, title: "Gallery of Elders", subtitle: "Portraits and voices", coords: [62, 48], duration: "4:55" },
      { n: 8, title: "Women's Stories", subtitle: "Held by the senior women", coords: [70, 62], duration: "6:12" },
      { n: 9, title: "Men's Stories", subtitle: "Held by the senior men", coords: [78, 52], duration: "5:38" },
      { n: 10, title: "Cattle Station Days", subtitle: "Working life on the frontier", coords: [84, 70], duration: "4:46" },
      { n: 11, title: "Mining & Memory", subtitle: "Gold, hardship, return", coords: [90, 60], duration: "5:24" },
      { n: 12, title: "Looking Forward", subtitle: "The next generation speaks", coords: [94, 80], duration: "4:18" },
    ],
  },
};

export const SERVICES = [
  { title: "Talking Trails Development", desc: "Complete planning, recording and delivery of place-based audio experiences." },
  { title: "Oral History Recording", desc: "Capture community stories and local knowledge before they disappear." },
  { title: "Cultural Interpretation", desc: "Support Traditional Owner storytelling and cultural engagement, led by community." },
  { title: "Heritage Storytelling", desc: "Transform local history into meaningful, layered visitor experiences." },
  { title: "Audio Production", desc: "Professional recording, editing and narrative development on Country." },
  { title: "Tourism Experience Design", desc: "Create distinctive visitor experiences rooted in place and people." },
];

export const SIGNAGE_SERVICES = [
  { title: "Interpretive Planning", desc: "Develop interpretation strategies and visitor experiences from concept to launch." },
  { title: "Signage Content Development", desc: "Create engaging content for interpretive signs and visitor infrastructure." },
  { title: "Audio Interpretation", desc: "Extend physical signage through digital storytelling, accessible via QR." },
  { title: "Cultural Interpretation", desc: "Support Traditional Owner-led storytelling and cultural authority." },
  { title: "Visitor Journey Design", desc: "Connect experiences across landscapes, destinations and seasons." },
  { title: "QR Enabled Experiences", desc: "Link physical infrastructure to rich, ever-evolving digital content." },
];

export const IDEAL_FOR = [
  "National Parks", "Indigenous Protected Areas", "World Heritage Areas", "Visitor Centres",
  "Local Government", "Museums", "Heritage Precincts", "Botanic Gardens",
  "Walking Trails", "Scenic Lookouts", "Cultural Sites", "Tourism Destinations",
];

export const PROCESS_STEPS = [
  { n: "01", title: "Listen", desc: "Understand place, purpose and the stories already living within a landscape." },
  { n: "02", title: "Curate", desc: "Design the visitor journey — what is heard, where, and by whom." },
  { n: "03", title: "Record", desc: "Capture voices, soundscapes and oral histories with care and consent." },
  { n: "04", title: "Build", desc: "Develop interpretation, audio, signage and digital experiences." },
  { n: "05", title: "Share", desc: "Launch experiences for visitors, communities and future generations." },
];
